window.Backbone = require 'backbone'
window.Backbone.$ = window.$

require '../../modules/tracking/frontend/initializer'
require '../../modules/buy_button/frontend/buy_button'
require '../../modules/buy_button/frontend/multi_option_modal'
require '../../modules/cash_back/frontend/cash_back'
require '../../modules/deal/frontend/channel_tabs'
require '../../modules/deal/frontend/controller'
require '../../modules/deal/frontend/external_links'
require '../../modules/deal_types/frontend/deal_type'
require '../../modules/gift_button/frontend/gift'
require '../../modules/g_map/frontend/main'
require '../../modules/external_deal/frontend/external_deal'
require '../../modules/sharing/frontend/facebook'
require '../../modules/deal/frontend/deal_lazy_loader'
require '../../modules/header/frontend/main'
require '../../modules/variations/frontend/variations-widget'
require '../../modules/inline_variations/frontend/inline_variations'
require '../../modules/doubleclick/frontend/dfp_ads'
require '../../modules/deal_widget/frontend/deal_widgets'
require '../../modules/urgency_messaging/frontend/countdown_timer'
require '../../modules/urgency_messaging/frontend/urgency_messaging'
require '../../modules/ad_unit/frontend/ad_unit_lazy_loader'

# external packages
require 'groupon-iframe-login'
require '../../node_modules/widget-layout-assets/coffee/wls'

####################################################
# packages that need to be updated to ITA 3        #
# it still works in this way but that's just dirty #
####################################################
# groupon-deal-timer
require '../../modules/groupon-deal-timer/common/helpers'
require '../../modules/groupon-deal-timer/frontend/models/countdown_timer'
require '../../modules/groupon-deal-timer/frontend/views/countdown_timer'
require '../../modules/groupon-deal-timer/frontend/countdown_timer'

# groupon-deal-carousel
require 'hogan.js'
require '../../modules/groupon-deal-carousel/frontend/swfobject-2.2'
require '../../modules/groupon-deal-carousel/frontend/detect-flash'
require '../../modules/groupon-deal-carousel/frontend/templates/main'
require '../../modules/groupon-deal-carousel/frontend/helpers'
require '../../modules/groupon-deal-carousel/frontend/models/media'
require '../../modules/groupon-deal-carousel/frontend/views/carousel'
require '../../modules/groupon-deal-carousel/frontend/carousel'

$(window).load ->
  Groupon.Performance.pageReady()
  Groupon.DFPAds?.load?()
  Groupon.DFPAds?.showAds?()
  AdUnitLazyLoader?.load()
